import { IRequest } from '@r1-frontend/shared/types/IRequest';

export type TAvailableSuggestions = 'fio' | 'address';

const suggest = (what: TAvailableSuggestions) => (query: string): IRequest => ({
    uri: `suggest/${what}`,
    method: 'POST',
    body: JSON.stringify({ query }),
});

export default suggest;
